import { configureRpc } from "./rpc-bridge.js";
import { AuthViewModel } from "./viewmodels/AuthViewModel.js";
import { useRPCContext } from "../../contexts/RPCContext.js";
import { AuthGate } from "./components/AuthGate.js";
import { FullScreenLoading } from "../../components/FullScreenLoading/index.js";
import "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
import { singleton } from "mvc-kit";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/index.tsx
function AuthWrapper2({ app, children }) {
	const { rpcClient, rpcService } = useRPCContext();
	configureRpc(rpcClient, rpcService);
	const authVM = singleton(AuthViewModel);
	authVM.setApp(app);
	authVM.init();
	const vm = useSingleton(AuthViewModel);
	if (vm.state.switchingUserProfile) return /* @__PURE__ */ jsx(FullScreenLoading, { statusMsg: "Switching User Profiles..." });
	if (!vm.state.authToken) return /* @__PURE__ */ jsx(AuthGate, {});
	if (vm.async.validateSession.loading) return /* @__PURE__ */ jsx(FullScreenLoading, { statusMsg: "Checking Authentication..." });
	if (!vm.state.identityInfo) return /* @__PURE__ */ jsx(FullScreenLoading, { statusMsg: "Getting Identity Info..." });
	return /* @__PURE__ */ jsx(Fragment$1, { children });
}
//#endregion
export { AuthWrapper2 };

//# sourceMappingURL=index.js.map